<template>
  <div class="news">
    <h3>新闻中心</h3>
    <ul>
      <li v-for="(item,index) in news" :key="index"><router-link :to='"/newsdetails?id="+item.newsId'>{{item.newsTitle}}</router-link></li>
    </ul>
  </div>
</template>
<script>
import Api from '@api/news'
export default {
  components: {
  },
  data(){
    return {
      news:[]
    }
  },

  created(){
    this.getNews();
  },
  methods:{
     getNews(){
      Api.fetchHomeList({}).then((res)=>{
        this.news=res.data.data
      })
    }
  }
}
</script>

<style lang="scss">
  .news{
    background:#e3ecf4;
    padding-bottom:57px;
    margin-top:70px;
    h3{
      font-size:32px;
      color:#333;
      line-height:110px;
      text-align: center;
    }
    a{
      display:block;
      font-size:28px;
      color:#2295fc;
      line-height:60px;
      margin-left:85px;
    }
  }
</style>
